export const CUSTOMER_LEVELS = {
  MADERA: 0,
  WOOD: 0,
  IRON: 1,
};

//Detail select
export const CUSTOMER_STATUS = [
  { label: 'Normal', value: '50995cbc-b7c2-4462-b279-41be2c40e435' },
  { label: 'Boletinado', value: '82c49bce-b66b-4cd0-8950-e0d4b476b3f7' },
  {
    label: 'Abuso de Confianza',
    value: '75070bcb-6a7b-4c93-aadd-a8aa1f8b753d',
  },
  { label: 'Corporativo', value: '72597466-87ac-49e7-a866-840910094f03' },
  { label: 'Extrajudicial', value: '7673529c-c304-4a08-a822-e5b8e8793c1a' },
  { label: 'Renta Diaria', value: '62cbc2a4-d2d2-4c91-9f08-8701eaae1350' },
  { label: 'Convenio de Pago', value: '2822080c-0dd8-49fc-8bb4-9a753b36f4dd' },
];

export const CUSTOMER_STATUS_VALUES = {
  NORMAL: '50995cbc-b7c2-4462-b279-41be2c40e435',
  BANNED: '82c49bce-b66b-4cd0-8950-e0d4b476b3f7',
  COVENANT: '2822080c-0dd8-49fc-8bb4-9a753b36f4dd',
};
